import { ModelSagres } from "../../model-sagres";

export class NormativoCargo extends ModelSagres {
  tipoAtoNormativo: number | null;
  numeroAtoNormativo: number | string | null;
  anoAtoNormativo: number | string | null;
  veiculoPublicacao: string;
  dataInicioVigencia: Date | string | null;

  constructor(obj?: any) {
    super();
    this.tipoAtoNormativo = obj?.tipoAtoNormativo ?? null;
    this.numeroAtoNormativo = obj?.numeroAtoNormativo ?? null;
    this.anoAtoNormativo = obj?.anoAtoNormativo ?? null;
    this.veiculoPublicacao = obj?.veiculoPublicacao ?? "";
    this.dataInicioVigencia = obj?.dataInicioVigencia ?? null;
  }
}
